import { skipToken, useSuspenseQuery } from '@apollo/client';

import type { SerpsListItem } from '@xing-com/crate-jobs-domain-serps-constants';
import { SeoLinkBoxesDocument } from '@xing-com/crate-jobs-domain-serps-graphql';

type UseSeoLinkBoxes = {
  linkboxes?: {
    kind: string;
    entries: SerpsListItem[];
  }[];
  error?: Error;
};

const allowedLinkboxes: string[] = ['nearby_job_role', 'related_job_roles'];

export const useJobDetailsLinkBoxes = ({
  location,
  jobRole,
}: {
  location?: string;
  jobRole: string;
}): UseSeoLinkBoxes => {
  const { data: jobRoleData, error: jobRoleError } = useSuspenseQuery(
    SeoLinkBoxesDocument,
    !jobRole
      ? skipToken
      : {
          variables: {
            jobRole,
            serpType: 'jobRole',
          },
          errorPolicy: 'all',
        }
  );
  const { data: localJobRoleData, error: localJobRoleError } = useSuspenseQuery(
    SeoLinkBoxesDocument,
    !jobRole || !location
      ? skipToken
      : {
          variables: {
            jobRole,
            serpType: 'local-jobRole',
            location: location?.toLocaleLowerCase().replace(/\s/g, '-'),
          },
          errorPolicy: 'all',
        }
  );
  const serialized = [
    ...(jobRoleData?.seoLinkBoxes?.collection || []),
    ...(localJobRoleData?.seoLinkBoxes?.collection || []),
  ].map((item) => {
    if (
      item === null ||
      item.entries === null ||
      !allowedLinkboxes.includes(item.kind)
    ) {
      return null;
    }

    return {
      kind: item.kind,
      entries: item.entries.map((entry) => ({
        id: entry?.name || '',
        link: { url: entry?.url || '', label: entry?.name || '' },
        count: entry?.jobCount || 0,
      })),
    };
  });

  return {
    linkboxes: serialized?.filter((item) => item !== null),
    error: jobRoleError || localJobRoleError,
  };
};
